import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

const path = '../../assets/js/worker.js';

@Injectable()
export class WorkerService {

    public response: Subject<string> = new Subject<string>();
    public result: Subject<any> = new Subject<any>();
    private _worker?: Worker;
    private isBusy = false;

    request(message: any, force: boolean = false) {
        if (force && this.isBusy) {
            this._worker?.terminate();
            this.process(message);
            this.response.next('FORCED START');
        }
        if (!force && this.isBusy) {
            this.response.next('WORKER IS BUSY');
        }
        if (!this.isBusy) {
            this.process(message);
            this.response.next('WORKER STARTED');
        }
    }

    process(message: any) {
        this.isBusy = true;
        this._worker = new Worker(path);
        this._worker.addEventListener('message', (e: MessageEvent) => {
            this.result.next(e.data);
        });
        this._worker.postMessage(message);

    }

    forceStop(): string {
        if (this.isBusy === true) {
            this._worker?.terminate();
            this.isBusy = false;
            return 'FORCED STOP';
        }
        return 'WORKER IS NOT RUNNING';
    }



    constructor() { }
}
